<template>
  <form @submit.prevent="onSearch">
    <div class="row">
      <div class="col-lg-2 col-md-6 col-sm-12">
        <Datepicker
            v-model="filters.toDate"
            position="down"
            label="bis Datum"
            placeholder="bis Datum"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <SelectVue
            v-model="filters.lastName"
            :options="unemployedDropdown"
            :is-clear="true"
            label="Nachname des Kunden"
            :showMinCharsMessage="true"
            :placeholder="$t('placeholder.last_name')"
            :no-options-text="'Type to search...'"
            @dropdown-fetch="(search) => handleDropdownSearch(search, 'lastName')"
            @update:modelValue="(val) => onSelectValue(val, 'lastName')"/>
      </div>
      <div class="col-lg-5 col-md-6 col-sm-12">
        <div v-if="officeDropdown && officeDropdown.length">
          <SelectVue
              v-model="filters.officeIds"
              :options="officeDropdown"
              :is-clear="true"
              :is-multi="true"
              :label="$t('placeholder.office_name')"
              placeholder="Wählen Sie Bezeichnung aus"/>
        </div>
      </div>
      <div class="col-lg-2 col-sm-12 col-12 pt-4">
        <SearchButton
            type="submit"
            :label="$t('general.button.search')"
            :loading="loading"/>
      </div>
    </div>
  </form>
</template>

<script setup>
import Datepicker from '@/components/picker/Datepicker.vue';
import SelectVue from '@/components/SelectVue.vue';
import {defineEmits, defineProps, toRefs} from 'vue';
import SearchButton from "@/components/button/SearchButton.vue";

const props = defineProps({
  filters: {
    type: Object,
    required: true,
  },
  unemployedDropdown: {
    type: Array,
    require: true,
  },
  officeDropdown: {
    type: Array,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['search']);
const {filters} = toRefs(props);

function onSearch() {
  emit('search', 1, undefined, filters.value);
}

function handleDropdownSearch(search, type) {
  emit('dropdown-fetch', search, type);
}

function onSelectValue(value, type) {
  if (!value) {
    emit('clear-dropdown', type);
  }
}

</script>

<style scoped>
</style>
